import { render, staticRenderFns } from "./catItem.vue?vue&type=template&id=ccf2128c&"
import script from "./catItem.vue?vue&type=script&lang=js&"
export * from "./catItem.vue?vue&type=script&lang=js&"
import style0 from "./catItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports